<template>
  <div class="" id="Login">
      <mt-header title="绑定激活码">
        <mt-button slot="right">跳过</mt-button>
      </mt-header>
    <div class="phone">
      <mt-field placeholder="请输入激活码" v-model="captcha"></mt-field>
    </div>
    <div class="login">
      <mt-button type="">确认</mt-button>
    </div>
  </div>
</template>

<script>
import {
  Swipe,
  SwipeItem,
  Indicator,
  Toast,
  Lazyload,
  InfiniteScroll,
  Header,
  Button,
  Field,
} from 'mint-ui';
import Vue from "vue";
Vue.component(Header.name,Header);
Vue.component(Button.name, Button);
export default {
  name: 'Login',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mintui-back{
  color: #2c2c2c;
}
.phone{
    margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Activation.vue